import { createAction, props } from '@ngrx/store';

import { ErrorMessage } from 'app/shared/error-handling';

import { KpiNotificationSettings } from '../kpi-notification-settings.model';

export const updateKpiSettings = createAction(
    '[Kpi Notification Settings] Update Report Kpi Notifications',
    props<{ reportId: string }>(),
);

export const loadKpiNotificationSettings = createAction(
    '[Kpi Notification Settings] Load Report Kpi Notifications',
    props<{ reportId: string }>(),
);

export const loadKpiNotificationSettingsSuccess = createAction(
    '[Kpi Notification Settings] Load Report Kpi Notifications Success',
    props<{ reportId: string; kpiNotificationSettings: KpiNotificationSettings }>(),
);

export const loadKpiNotificationSettingsError = createAction(
    '[Kpi Notification Settings] Load Report Kpi Notifications Error',
    props<{ error: ErrorMessage }>(),
);

export const saveKpiNotificationSettings = createAction(
    '[Kpi Notification Settings] Save Report Kpi Notifications',
    props<{ reportId: string; kpiNotificationSettings: KpiNotificationSettings }>(),
);

export const saveKpiNotificationSettingsSuccess = createAction(
    '[Kpi Notification Settings] Save Report Kpi Notifications Success',
    props<{ reportId: string; kpiNotificationSettings: KpiNotificationSettings }>(),
);

export const saveKpiNotificationSettingsError = createAction(
    '[Kpi Notification Settings] Save Report Kpi Notifications Error',
    props<{ error: ErrorMessage }>(),
);
